import { apiRequest } from "./apiClient";

export interface LoginResponse {
    token: string;
    doctor: any;
    praxis: any;
}

export function loginApi(praxis: string, username: string, password: string) {
    return apiRequest<LoginResponse>(
        `/api/login`,
        {
            method: "POST",
            body: JSON.stringify({ praxis, email: username, password }),
        },
        { "Content-Type": "application/json" },
    );
}
